/**
 * Parses an audit time from the server. New records are UTC ISO ("2026-10-09T01:02:03.456789Z").
 * Records written before 2026-10 have no zone ("2026-09-30 10:11:12.5"); they are read as UTC,
 * as the panel always did (the server's offset is unknown to the client).
 */
export const parseServerDate = (s?: string | null): Date | null => {
  if (!s) return null
  const m = s.trim().match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2})?)(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/i)
  if (!m) return null
  const [, date, time, frac = "", zone] = m
  const ms = frac ? frac.slice(0, 4).padEnd(4, "0") : ""
  const tz = zone ? zone.toUpperCase().replace(/^([+-]\d{2})(\d{2})$/, "$1:$2") : "Z"
  const d = new Date(`${date}T${time}${ms}${tz}`)
  return isNaN(d.getTime()) ? null : d
}
